export default __webpack_public_path__ + "a4a099cafd07994a6465070cfb631798.svg";